import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery, useTheme } from '@mui/material';
import SiteHeader from '../../components/SiteHeader';
import SideBar from '../../components/SideBar';
import MobileNavigation from '../../components/MobileNavigation';
import { Grid, Box } from '@mui/material';

const AuthAdminLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <main>
      <div className="authLogin">
        <Grid container>
          {/* Sidebar - hidden on mobile, shown on desktop */}
          <Grid 
            item 
            width={{xs: 0, lg: 300}} 
            display={{xs: 'none', lg: 'block'}}
            sx={{ 
              position: 'fixed',
              left: 0,
              top: 0,
              height: '100vh',
              zIndex: 1200
            }}
          >
            <SideBar />
          </Grid>
          
          {/* Main content area */}
          <Grid 
            item 
            width={{xs: '100%', lg: 'calc(100% - 300px)'}}
            sx={{ 
              marginLeft: {xs: 0, lg: '300px'},
              minHeight: '100vh',
              paddingBottom: isMobileView ? '80px' : '0'
            }}
          >
            <Grid item container>
              <Grid item xs={12}>
                <SiteHeader />
              </Grid>
              <Grid item xs={12}>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Mobile Navigation - only show on mobile */}
        {isMobileView && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: '#1a1d26',
              borderTop: '1px solid #333',
              zIndex: 1300,
              padding: '8px 0'
            }}
          >
            <MobileNavigation userType="admin" />
          </Box>
        )}
      </div>
    </main>
  );
};

AuthAdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthAdminLayout;
